// extracted by mini-css-extract-plugin
export default {"container":"TotalCard_container__9HtdU","valueContainer":"TotalCard_valueContainer__lPSGe"};